import {DismissButton, Overlay, usePopover} from 'react-aria';
import type {AriaPopoverProps} from 'react-aria';
import type {OverlayTriggerState} from 'react-stately';
import {useRef} from "react";

interface PopoverProps extends Omit<AriaPopoverProps, 'popoverRef'> {
    children: React.ReactNode;
    state: OverlayTriggerState;
    className?: string;
}

export function Popover({children, state, className, offset = 8, ...props}: PopoverProps) {

    const popoverRef = useRef(null);
    const {popoverProps, underlayProps} = usePopover({
        ...props,
        offset,
        popoverRef
    }, state);

    return (
        <Overlay>
            <div {...underlayProps} className="fixed inset-0" />
            <div {...popoverProps} ref={popoverRef}
                className={`flex absolute bg-[rgba(255,255,255,0.95)] border border-gray-300 rounded-md shadow-lg mt-1 z-10 ${className}`}>
                <DismissButton onDismiss={state.close} />{children}<DismissButton onDismiss={state.close} />
            </div>
        </Overlay>
    );
}